import React from 'react';
import PropTypes from 'prop-types';
import { Tabs } from 'react-bootstrap';
import style from './TabbedView.scss';

const propTypes = {
  showTabs: PropTypes.bool,
  children: PropTypes.any.isRequired,
};

const TabbedView = ({ showTabs, children }) => (
  <div className={style.tabContainer}>
    {
      showTabs ? (
        <Tabs defaultActiveKey={0} id="tabbed-list-view">
          {React.Children.map(
            children,
            (element, index) => element && React.cloneElement(element, { eventKey: index }),
          )}
        </Tabs>
      ) : children
    }
  </div>
);

TabbedView.propTypes = propTypes;

export default TabbedView;
